import { getRootUrl } from '@share-a-cart/shared-utils';
import dayjs from 'dayjs';
import type { CartHistoryData } from 'src/types';
import { utils, writeFile } from 'xlsx';

export type CartHistoryToExcelRows = {
  'Created or Received?': string;
  Vendor: string | undefined;
  ID: string;
  Title: string;
  'Creation Date': string;
  Visibility: string;
  'Item Qty': number;
  'Currency Symbol': string;
  'Total Price': number | string;
  Currency: string;
  Note: string;
  Tags: string;
  'Link to Cart': string;
};

export const exportCartHistoryToExcel = (
  data: {
    carts: CartHistoryData[];
    pageParam: number;
  }[],
) => {
  const rows: CartHistoryToExcelRows[] = [];

  data.forEach((group) => {
    group.carts.forEach((cart) => {
      rows.push({
        'Created or Received?': cart.created ? 'Created' : 'Received',
        Vendor: cart.vendorDisplayName || cart.cart.vendor,
        ID: cart.cart.id.toUpperCase(),
        Title: cart.cart.title || '',
        'Creation Date': dayjs(cart.cart.timestamp).format("D MMM 'YY"),
        Visibility: cart.listed ? 'Public' : 'Private',
        'Item Qty': cart.cart.cartTotalQty || 0,
        'Currency Symbol': cart.cart.cartCCYS || '$',
        'Total Price': cart.cart.cartTotalPrice || 0,
        Currency: cart.cart.cartCCY || 'USD',
        Note: cart.note || '',
        Tags: cart.tags?.join(', ') || '',
        'Link to Cart': `${getRootUrl()}/get/${cart.cart.id}`,
      });
    });
  });

  // @ts-expect-error - TS error but still works.
  const ws = utils.json_to_sheet(rows, { origin: 'A3' });
  const wb = utils.book_new();

  // add hyperlinks to Link to Cart column
  for (let i = 4, j = 0; j < rows.length; i++, j++) {
    ws[`M${i}`].l = {
      Target: ws[`L${i}`].v,
    };
  }

  utils.book_append_sheet(wb, ws, 'Carts');

  utils.sheet_add_aoa(ws, [['Share-A-Cart.com']], { origin: 'A1' });
  ws['A1'].l = {
    Target: `${getRootUrl()}`,
  };

  utils.sheet_add_aoa(
    ws,
    [[`Sheet Created: ${dayjs(Date.now()).format('D MMM YYYY, h:mm A')}`]],
    {
      origin: 'C1',
    },
  );

  // Column Widths
  const wscols = [
    {
      // Created or Received?
      wch: 20,
    },
    {
      // Vendor
      wch: 16,
    },
    {
      // ID
      wch: 10,
    },
    {
      // Title
      wch: 25,
    },
    {
      // Creation Date
      wch: 12,
    },
    {
      // Visibility
      wch: 20,
    },
    {
      // Item Qty
      wch: 10,
    },
    {
      // Currency Symbol
      wch: 20,
    },
    {
      // Total Price
      wch: 10,
    },
    {
      // Currency
      wch: 20,
    },
    {
      // Note
      wch: 40,
    },
    {
      // Tags
      wch: 20,
    },
    {
      // Link to Cart
      wch: 40,
    },
  ];
  ws['!cols'] = wscols;
  writeFile(wb, 'Carts.xlsx');
};
